import { Movement, Product } from '../types'

export interface StockManagementState {
  product: Product | null
  productTabs: ProductTabs
  flvRuleDayPeriod?: string
  flvProductInfoForRelease: FlvProductInfoForRelease[]
  selectedFlvProducts: FlvProductInfoForRelease[]
}

export interface GetProduct {
  fulfillmentCenterId?: number,
  modelId?: number,
}

export interface Reserve {
  id: number,
  orderCode: string,
  quantity: number,
  deliveryDate: string,
  reserveDate: string,
  sourceSystem: string,
}

export interface ProductTabs {
  reserves: {
    items: Reserve[],
    totalItems: number
  }
  filters: {
    fulfillmentCenterId?: number,
    modelId?: number
    startDate?: Date,
    endDate?: Date
  }
  barcodes: Barcode[]
  movements: MovementTab,
  movementsByType: MovementByType[],
}

export interface MovementTab {
  items: Movement[],
  totalItems: number,
  page: number
}

export interface Barcode {
  barcode: string,
  barcodeOrder: number,
  modelId?: number,
  type: string,
  packQty: number,
}

export interface UpOrDownOrderBarcode {
  barcode: string,
  type: string,
  order: number,
  modelId: number,
}

export interface ProductTabsFilters {
  fulfillmentCenterId?: number
  modelId?: number
  startDate?: Date,
  endDate?: Date
}

export enum MovementEnum {
  RECEIVEMENT = 'RECEIVEMENT',
  DAMAGED = 'DAMAGED',
  CHECKOUT = 'CHECKOUT',
  MATURATION = 'MATURATION',
  REFUND = 'REFUND',
  EXPIRED_DUE_DATE = 'EXPIRED_DUE_DATE',
  'ADJUSTMENT (+)' = 'ADJUSTMENT (+)',
  'ADJUSTMENT (-)' ='ADJUSTMENT (+)'
}

export interface MovementByType {
  type: MovementEnum,
  balances: { date: string, balance: number }[]
}

export interface EditBarcode {
  badge?: string,
  barcode?: string,
  modelId?: number,
}

export enum GenericApiErrors {
  Failed,
}

export interface InsertBarcodeParams {
  barcode: string,
  modelId?: number,
  onSuccess?: () => void
  packQty?: number
}

export interface GetFlvProductInfoForReleasePayload {
  fulfillmentCenterId?: number,
  selectedDayPeriod: string,
  productsCodes?: string[]
  productDescription?: string
}

export interface FlvProductInfoForReleaseData {
  dayPeriod: string
  flvProductInfo: FlvProductInfoForRelease[]
}

export interface FlvProductInfoForRelease {
  id: number
  idFulfillmentCenter: number
  fulfillmentCenterName: string
  idModel: number
  productCode: string
  productDescription: string
  availableQuantityFromPunctual: number
  totalStocks: number
  availableStock: number
  samedayLimit?: number
}

export interface SetProperty {
  property: keyof StockManagementState
  value: StockManagementState[keyof StockManagementState]
}

export interface FlvProductsUpdateAvailability {
  idsModel: number[]
  idFulfillmentCenter: number
}

export interface FlvProductUpdateAvailabilityPayload {
  dayPeriod: string
  products: FlvProductsUpdateAvailability[]
}

export interface GetInvoiceToPrintPayload {
  invoiceKey: string
  onSuccess: (invoiceHtml: string) => void
}

export enum FlvRuleDayPeriodEnum {
  MORNING = 'Diurna',
  NIGHT = 'Noturna',
}
